function DialogTrigger(callback, options) {
	// Becomes this.options
	var defaults = {
		trigger	: 'timeout',
		target	: '',
		timeout	: 0,
		percentDown : 50, // Used for 'percent' to define a down scroll threshold of significance (based on page height)
		percentUp : 10, // Used for 'percent' to define a threshold of upward scroll after down threshold is reached
		scrollInterval: 250, // Frequency (in ms) to check for scroll changes (to avoid bogging the UI)
		exitSensitivity: 20, // How close to top edge (in px) the cursor must be for exit-intent
		minTimeOnPage: 0, // Minimum time on page before exit-intent can trigger
		minScrollForExit: 0 // Optional minimum scroll % before exit-intent can trigger
	}
	
	this.complete = false; // Let's us know if the popup has been triggered
	
	this.callback = callback;
	this.timer = null;
	this.interval = null;
	this.mouseLeaveHandler = null;
	this.eventNamespace = '.dialogTrigger' + DialogTrigger._nextId++;
	this.startedAt = Date.now();
	
	this.options = jQuery.extend(defaults, options);

	this.getScrollableHeight = function() {
		var scrollableHeight = jQuery(document).height() - jQuery(window).height();
		return Math.max(scrollableHeight, 1);
	};

	this.getScrollPercent = function() {
		return (parseFloat(jQuery(window).scrollTop()) / parseFloat(this.getScrollableHeight())) * 100;
	};

	this.clearResources = function() {
		if(this.timer !== null) {
			clearTimeout(this.timer);
			this.timer = null;
		}
		
		if(this.interval !== null) {
			clearInterval(this.interval);
			this.interval = null;
		}

		jQuery(document).off('mouseleave' + this.eventNamespace);
	};

	this.fire = function() {
		if(this.complete) {
			return;
		}

		this.complete = true;
		this.clearResources();
		this.callback();
	};
	
	this.init = function() {
		if(this.options.trigger == 'exitIntent' || this.options.trigger == 'exit_intent') {
			var parentThis = this;
			
			this.mouseLeaveHandler = function(e) {
				var relatedTarget = e.relatedTarget || e.toElement;
				if(relatedTarget) {
					return;
				}

				var isNearTop = typeof e.clientY === 'number' ? e.clientY <= parseFloat(parentThis.options.exitSensitivity) : true;
				if(!isNearTop) {
					return;
				}

				var spentEnoughTime = (Date.now() - parentThis.startedAt) >= parseFloat(parentThis.options.minTimeOnPage);
				if(!spentEnoughTime) {
					return;
				}

				if(parseFloat(parentThis.options.minScrollForExit) > 0 && parentThis.getScrollPercent() < parseFloat(parentThis.options.minScrollForExit)) {
					return;
				}

				parentThis.fire();
			};

			jQuery(document).on('mouseleave' + this.eventNamespace, this.mouseLeaveHandler);

		} else if(this.options.trigger == 'target') {
			if(this.options.target !== '') {
				var parentThis = this;
					
				// Only check the scroll position every few milliseconds, to avoid bogging the UI
				this.interval = setInterval(function() {
					var targetElement = jQuery(parentThis.options.target);

					if(targetElement.length == 0) {
						parentThis.cancel();
						return;
					}

					var targetScroll = targetElement.offset().top;
					var viewportBottom = jQuery(window).scrollTop() + jQuery(window).height();
					if(viewportBottom >= targetScroll) {
						parentThis.fire();
					}
				}, this.options.scrollInterval);
			} else {
				this.complete = true;
			}

		} else if(this.options.trigger == 'scrollDown') {
			// Let the user scroll down by some significant amount.
			var scrollStart = jQuery(window).scrollTop();
			var maxScrollTop = scrollStart;
			var downThreshold = (parseFloat(this.options.percentDown) / 100) * this.getScrollableHeight();
			var parentThis = this;

			this.interval = setInterval(function() {
				var currentScrollTop = jQuery(window).scrollTop();
				if(currentScrollTop > maxScrollTop) {
					maxScrollTop = currentScrollTop;
				}
				var downScrollAmount = maxScrollTop - scrollStart;
				
				if(downScrollAmount >= downThreshold) {
					parentThis.fire();
				}
			}, this.options.scrollInterval);

		} else if(this.options.trigger == 'scrollUp') {
			// Let the user scroll up by some significant amount.
			var maxScrollTop = jQuery(window).scrollTop();
			var upThreshold = (parseFloat(this.options.percentUp) / 100) * this.getScrollableHeight();
			var parentThis = this;

			this.interval = setInterval(function() {
				var currentScrollTop = jQuery(window).scrollTop();
				if(currentScrollTop > maxScrollTop) {
					maxScrollTop = currentScrollTop;
				}
				var upScrollAmount = maxScrollTop - currentScrollTop;
				
				if(upScrollAmount >= upThreshold) {
					parentThis.fire();
				}
			}, this.options.scrollInterval);

		} else if(this.options.trigger == 'timeout') {
			var parentThis = this;
			this.timer = setTimeout(function() {
				parentThis.fire();
			}, this.options.timeout);
		} else {
			this.complete = true;
		}
		
    };
	
	this.cancel = function() {
		if(this.complete) {
			return;
		}
		
		this.clearResources();
		this.complete = true;
	}

    this.init();
}
DialogTrigger._nextId = 1;
window.DialogTrigger = DialogTrigger;
